import React from 'react';

const CursoFilterBar = ({ filters, onChange }) => {
  return (
    <div className="mb-4 w-full max-w-md">
      <div className="relative">
        <input
          type="text"
          name="nome"
          placeholder="Buscar por nome do curso..."
          value={filters.nome}
          onChange={onChange}
          className="w-full px-3 py-2 pr-8 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400"
        />
      </div>
    </div>
  );
};

export default CursoFilterBar;
